import { render } from "./RepeatableMediaInput.vue?vue&type=template&id=3b60a555&scoped=true"
import script from "./RepeatableMediaInput.vue?vue&type=script&lang=js"
export * from "./RepeatableMediaInput.vue?vue&type=script&lang=js"

import "./RepeatableMediaInput.vue?vue&type=style&index=0&id=3b60a555&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b60a555"]])

export default __exports__